import React, { useEffect } from 'react';
import { Typography, Row, Col, Divider } from 'antd';
import '../../Styles/ResearchLabs.css';

import AppHeader from '../../Layout/Header';
import FooterComponent from '../../Layout/Footer';

import istlogo from '../../Assets/Brand/ist-logo.png';
import istCampus from '../../Assets/ResearchLabs/Common/IST-Campus.jpg';

// Banner image
import gserlBanner from '../../Assets/ResearchLabs/GSERL/gserlbanner.jpg';

import GSerlDomain from './GSERL Components/GserlDomain';
import GserlScope from './GSERL Components/GserlScope';
import GSerlHead from './GSERL Components/GSerlHead';
import Impact from './GSERL Components/Impact';
import SocialFeed from './GSERL Components/SocialFeed';

const { Title } = Typography;

const SpaceEducationandResearchLab = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);
    return (
        <>
            <AppHeader />
            <main className="individual-lab-page">

            {/* Lab Banner */}
            <div
                className="sarl-lab-hero"
                role="img"
                aria-label="GNSS and Space Education Research Lab"
                style={{
                    backgroundImage: `url(${gserlBanner})`
                }}
            >
                
            </div>

            {/* Host University */}
            <section className="sarl-host-section">
                <div className="sarl-host-inner">

                    <Row
                        gutter={[72, 40]}
                        align="middle"
                        justify="space-between"
                    >
                        <Col xs={24} md={11}>
                            <Title
                                level={2}
                                className="sarl-host-title"
                            >
                                Host University
                            </Title>

                            <Divider className="ncgsa-divider" />

                            <div className="sarl-host-identity">
                                <img
                                    src={istlogo}
                                    alt="Institute of Space Technology logo"
                                    className="sarl-host-logo"
                                />

                                <Title
                                    level={5}
                                    className="sarl-host-name"
                                >
                                    Institute of Space Technology, Islamabad
                                </Title>
                            </div>
                        </Col>

                        <Col xs={24} md={10}>
                            <img
                                src={istCampus}
                                alt="Institute of Space Technology campus"
                                className="sarl-host-campus"
                            />
                        </Col>
                    </Row>

                </div>
            </section>

            {/* Lab Sections */}
            <GserlScope />
            <GSerlDomain />
            <Impact/>
            <GSerlHead />
            <SocialFeed/>
            </main>

            <FooterComponent />
        </>
    );
};

export default SpaceEducationandResearchLab;
